import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  href: string;
  children: React.ReactNode;
  tone?: 'gold' | 'dark';
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  href,
  children,
  tone = 'gold',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const toneClass = tone === 'gold' ? 'bg-gold text-ink hover:bg-gold-light focus-visible:ring-gold-light focus-visible:ring-offset-ink' : 'bg-umber text-parchment hover:bg-ink focus-visible:ring-umber focus-visible:ring-offset-parchment';
  const sizeClass = size === 'lg' ? 'h-12 px-6 text-xs md:h-14 md:px-8 md:text-sm' : 'h-10 px-5 text-xs';
  return <a href={href} className={`group inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-full font-sans font-semibold uppercase tracking-[0.14em] transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-[0.98] ${toneClass} ${sizeClass} ${className}`} data-id="element-74" data-mp="10cg94gpk1n9m">
      {children}
      <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-75" data-mp="35y7i8daaiuyg" />
    </a>;
}